define("settings/controllers/overview", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency", "later/utils/fetch", "shared/utils/constants/days"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _tracking, _emberConcurrency, _fetch, _days) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/fetch",0,"shared/utils/constants/days"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const TWO_FACTOR_ALERT_CACHE_KEY = 'closed-two-factor-alert';

  // TODO: fix this
  // eslint-disable-next-line
  let OverviewController = _exports.default = (_class = class OverviewController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "cache", _descriptor3, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor4, this);
      _initializerDefineProperty(this, "errors", _descriptor5, this);
      _initializerDefineProperty(this, "intl", _descriptor6, this);
      _initializerDefineProperty(this, "laterConfig", _descriptor7, this);
      _initializerDefineProperty(this, "locale", _descriptor8, this);
      _initializerDefineProperty(this, "router", _descriptor9, this);
      _initializerDefineProperty(this, "store", _descriptor10, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor11, this);
      _initializerDefineProperty(this, "account", _descriptor12, this);
      _initializerDefineProperty(this, "user", _descriptor13, this);
      _initializerDefineProperty(this, "instagramProfiles", _descriptor14, this);
      _initializerDefineProperty(this, "socialProfiles", _descriptor15, this);
      _defineProperty(this, "queryParams", ['openMobileModal']);
      _defineProperty(this, "toggleTwoFactor", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.otp_required) {
            yield this.openDisableModal();
          } else {
            this.openModal();
          }
        }
      }), null, "toggleTwoFactor", null));
    }
    get userLocaleName() {
      return this.locale.userLocaleName;
    }
    get canAiCredits() {
      const {
        canHideAiFeatures
      } = this.auth.currentAccount;
      return !canHideAiFeatures && this.subscriptions.subscriptionPlan?.numberOfAiCredits > 0;
    }
    get days() {
      return (0, _days.default)(this.intl);
    }
    get firstDayWeek() {
      const firstDayIndex = this.auth.currentUserModel.firstDay || 0;
      const firstDay = this.days.find(day => day.wday == firstDayIndex);
      if (!firstDay) {
        return this.days[0].name;
      }
      return firstDay.name;
    }
    get otp_required() {
      return this.auth.currentUserModel.otp_required_for_login;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get leaveLaterDescription() {
      return this.isMobileSubscription ? this.intl.t('account.overview.leave_later.description_mobile', {
        platform: this.subscriptions.platform
      }) : this.intl.t('account.overview.leave_later.description');
    }
    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }
    get upcomingSubscriptionPlan() {
      return this.subscriptions.upcomingSubscriptionPlan;
    }
    get allAnalyticsEmails() {
      return this.instagramProfiles.every(profile => profile.analyticsEmail);
    }
    get canEnableTwoFactor() {
      return Boolean(this.auth.currentAccount.rolloutTwoFactor || this.otp_required);
    }
    get reenableTwoFactorMessage() {
      return {
        type: 'info',
        title: this.intl.t('account.two_factor.reenable_title'),
        message: this.intl.t('account.two_factor.reenable_desc')
      };
    }
    get showTwoFactorAlert() {
      return Boolean(this.otp_required && !this.cache.retrieve(TWO_FACTOR_ALERT_CACHE_KEY));
    }
    get accountSettingsBaseUrl() {
      const baseUrl = this.laterConfig.keycloakAuthUrl;
      return `${baseUrl}/portal/profile`;
    }
    get managePersonalInfoUrl() {
      return `${this.accountSettingsBaseUrl}/general`;
    }
    get manageSignInUrl() {
      return `${this.accountSettingsBaseUrl}/signin`;
    }
    logout() {
      this.auth.logout.perform();
    }
    closeTwoFactorAlert() {
      this.cache.add(TWO_FACTOR_ALERT_CACHE_KEY, true, {
        expiry: this.cache.maxExpiryDate(),
        persist: true
      });
    }
    openModal() {
      this.router.transitionTo('account.overview.two_factor');
    }
    async openDisableModal() {
      const didConfirm = await this.dialogManager.confirmation(this.intl.t('account.two_factor.disable_two_factor_header'), {
        description: this.intl.t('account.two_factor.disable_two_factor_message'),
        confirmButton: this.intl.t('account.two_factor.disable_two_factor_button')
      });
      if (didConfirm) {
        await this.disable();
      }
    }
    async disable() {
      try {
        const user = await (0, _fetch.fetch)(`/api/v2/users/disable_two_factor`, {
          method: 'PATCH'
        });
        this.store.pushPayload(user);
        this.alerts.success(this.intl.t('alerts.account.two_factor.disable_complete'));
      } catch (error) {
        this.errors.log(error);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "laterConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "account", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "user", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "instagramProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "socialProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class.prototype, "logout", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTwoFactorAlert", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTwoFactorAlert"), _class.prototype)), _class);
});